import { common as esCommon } from './es/common';
import { common as enCommon } from './en/common';
import { common as ruCommon } from './ru/common';

export const resources = {
  es: {
    common: esCommon
  },
  en: {
    common: enCommon
  },
  ru: {
    common: ruCommon
  }
};